const Unit = {
  spacing: '0.9375rem',
  pagePadding: '1.875rem',
  columnWidth: '25%',
  columnPadding: '3.75rem',
  columnPaddingWide: '5.625rem',
};

export const calcColumnWidth = (spanColumns = 1, bleed = 0, edge = false) => {
  const spacing = 0.9375;
  const gutter = 4 * spacing;
  const columnWidth = 27 * spacing;
  const bleedWidth =
    bleed > 0
      ? (spanColumns - Number.isInteger(spanColumns) ? 1 : 0.5) *
        (gutter + gutter * bleed)
      : spanColumns > 1 ? Math.floor(spanColumns-0.5) * gutter : 0;
  const edgeWidth = !edge ? 0 : gutter;
  const width = spanColumns * columnWidth + bleedWidth + edgeWidth;
  return `${width}rem`;
};

export const calcColumnWidthPercentage = (spanColumns = 1, parentColumns = 4) => {
  parentColumns = parentColumns || 4;
  return `${(spanColumns / parentColumns) * 100}%`;
};

//columns = 4
//column width = 27 * spacing = 405px
//gutter = 4 * spacing = 60px
//page margin = 4 * spacing = 60px

// 1 col = column width
// 1 col + bleed = column width + (gutter * 0.5)
// 2 col = (2 * column width) + (gutter * 1)
// 2 col + bleed = (2 * column width) + (gutter * 1.5)
// 3 col = (3 * column width) + (gutter * 2)
// 3 col + bleed = (3 * column width) + (gutter * 2.5)
// 4 col = (4 * column width) + (gutter * 3)

export default Unit;



// WEBPACK FOOTER //
// ./src/styles/units.js